import * as React from 'react';

import { ExternalCoachAction } from 'bundles/ai-coach-platform/components/patterns/chat/ExternalCoachAction';
import { useCoachState } from 'bundles/unified-common/providers/CoachStateProvider';
import { useCareerRolesData } from 'bundles/unified-description-page-common/contexts/CareerRolesDataContext';
import { useSpecializationPageData } from 'bundles/unified-description-page-common/contexts/consumer/ConsumerBffSpecializationContext';
import { useCoachCareerFitAssistantExperimentData } from 'bundles/unified-description-page-common/providers/specialization/CoachCareerFitAssistantExperimentProvider';

import _t from 'i18n!nls/xdp';

const COACH_MODE_ID = 'XDP_CAREER_FIT_ASSISTANT';
const COACH_BUTTON_ACTION_ID = 'IS_THIS_RIGHT_FOR_ME';
const COACH_TYPED_MESSAGE_ACTION_ID = 'TYPED_MESSAGE';

const CoachButton = () => {
  const { setCoachOpen, setContextConfig } = useCoachState();

  const { coachCareerFitAssistantEnabled } = useCoachCareerFitAssistantExperimentData();
  const specializationPageData = useSpecializationPageData();
  const { data: careerRolesData } = useCareerRolesData();
  const careerRoleData = careerRolesData?.[0];

  if (!coachCareerFitAssistantEnabled || !specializationPageData) {
    return null;
  }

  const label = _t('Is this right for me?');

  const coachActionButtonConfig = {
    courseraContext: {
      specializationId: specializationPageData.id,
    },
    config: {
      coachModeId: COACH_MODE_ID,
      coachActionId: COACH_BUTTON_ACTION_ID,
    },
    message: label,
    ...(careerRoleData
      ? {
          additionalContext: [
            {
              contextKey: 'additionalContext.roleData',
              contextValue: `role-name: ${careerRoleData.name}, role-slug: ${careerRoleData.slug}, role-median-salary: ${careerRoleData.jobPostingData?.medianSalary}, role-num-jobs-available: ${careerRoleData.jobPostingData?.numJobsAvailable}, role-currency-code: ${careerRoleData.jobPostingData?.currencyCode}`,
            },
          ],
        }
      : {}),
  };

  return (
    <ExternalCoachAction
      size="small"
      key="coach"
      variant="secondary"
      newSessionOnClick={false}
      onClick={() => {
        const { message, ...coachChatContext } = coachActionButtonConfig;
        setContextConfig({
          ...coachChatContext,
          config: {
            coachModeId: COACH_MODE_ID,
            coachActionId: COACH_TYPED_MESSAGE_ACTION_ID,
          },
        });
        setCoachOpen(true);
      }}
      label={label}
      {...coachActionButtonConfig}
    />
  );
};

export default CoachButton;
